import _styled2 from "styled-components";
import _styled from "styled-components";
import React from "react";
import Icon from "../../atoms/icon/icon.component.js";
function EditRemove({
  children,
  onEdit,
  onDelete,
  onView,
  viewMode
}) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children, onEdit && /* @__PURE__ */ React.createElement(_StyledIcon, {
    role: "edit-action",
    hidden: viewMode,
    color: "var(--secondaryColor)",
    name: "edit",
    onClick: onEdit
  }), onDelete && /* @__PURE__ */ React.createElement(_StyledIcon2, {
    role: "delete-action",
    hidden: viewMode,
    color: "var(--secondaryColor)",
    name: "trash-alt",
    onClick: onDelete
  }), onView && /* @__PURE__ */ React.createElement(Icon, {
    role: "view-action",
    color: "var(--secondaryColor)",
    name: "eye",
    onClick: onView
  }));
}
export default {
  EditRemove: /* @__PURE__ */ React.memo(EditRemove)
};
var _StyledIcon = _styled(Icon).withConfig({
  displayName: "data-table-actionscomponent___StyledIcon",
  componentId: "sc-5f7qe8-0"
})({
  marginRight: "0.5rem"
});
var _StyledIcon2 = _styled(Icon).withConfig({
  displayName: "data-table-actionscomponent___StyledIcon2",
  componentId: "sc-5f7qe8-1"
})({
  marginRight: "0.5rem"
});
